import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { InputDateDirective } from "./input-date.directive";
import { ButtonDirective } from "./button.directive";
import { InputDirective } from "./input.directive";
import { AutofocusDirective } from "./autofocus.directive";
import { GooglePlaceDirective } from "./google-places-directive/google-places.directive";
import { ContentEditableDirective } from "./content-editable.directive";
import { HighlightMatchEditableDirective } from "./highlight-match-editable.directive";
import { HighlightMatchDirective } from "./hightlight-match.directive";

@NgModule({
  declarations: [
    InputDateDirective,
    ButtonDirective,
    InputDirective,
    AutofocusDirective,
    GooglePlaceDirective,

    ContentEditableDirective,
    HighlightMatchEditableDirective,
    HighlightMatchDirective,
  ],
  imports: [CommonModule],
  exports: [
    InputDateDirective,
    ButtonDirective,
    InputDirective,
    AutofocusDirective,
    GooglePlaceDirective,

    ContentEditableDirective,
    HighlightMatchEditableDirective,
    HighlightMatchDirective,
  ],
})
export class AppDirectivesModule {}
